export const REQ_TYPE = {
  FETCH_LIST: 'FETCH_LIST',
  LOAD_MORE: 'LOAD_MORE',
  EDIT_NOTIFICATION_BY_SELF: 'EDIT_NOTIFICATION_BY_SELF',
  ADD: 'ADD',
};
